export const ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || "";

export const RE_CAPTCHA_SITE_KEY = process.env.REACT_APP_RE_CAPTCHA_SITE_KEY || "1";

export const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY || "";
